import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { updatePath, useSyncRouter } from './slice';

export const SyncRouterProvider = (props) => {
    const { children } = props;
    useSyncRouter();
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            updatePath({
                fullPath: `${location.pathname}${location.search}`,
                path: location.pathname,
                searchQuery: location.search,
            }),
        );
    }, [dispatch, location.pathname, location.search]);
    return <>{children}</>;
};
